import React from 'react'
import styled from 'styled-components';
import {colours} from '../Styles';

function ContactForm() {
    const { transpBlack, dark, transpWhite} = colours;
    const ContactForm = styled.form`
        width: 600px;
        margin-bottom: 40px;
        div {
            position: relative;
        }
        div label {
            position: absolute;
            font-family: play, sans-serif;
            font-size: 12px;
            transform: translateX(10px) translateY(13px);
        }
        input, textarea {
            width: 100%;
            height: 40px;
            background: ${transpWhite};
            border: none;
            border-radius: 10px;
            color: ${transpBlack};
            font-size: 16px;
            font-family: montserrat, sans-serif;
            text-align: center;
            margin-bottom: 10px;
            transition: 500ms;
            :focus {
                border: 2px solid ${dark};
                border-radius: 10px;
                outline: none;
            }
        }
        textarea {
            height: 100px;
            padding-top: 10px;
            padding-left: 70px;
            text-align: left;
        }
        button {
            width: 100px;
            height: 30px;
            background: ${transpWhite};
            border: 1px solid ${transpBlack};
            font-family: Play, sans-serif;
            color: black;
            border-radius: 10px;
            transition: 500ms;
            cursor: pointer;
            :hover {
                border: 1px solid ${transpWhite};
                background: ${transpBlack};
                color: white;
            }
        }
        @media only screen and (max-width: 600px) {
            width: 80%;
        }
        
    `;
    return (
        <ContactForm id="contact-form" method="post" action="contact-form-handler.php">
            <div>
                <label for="name">Name:</label>
                <input class="form-control" type="text" id="name" name="name" required/>
            </div>
            <div>
                <label for="email">Email:</label>
                <input class="form-control" type="email" id="email" name="email" required/>
            </div>
            <div>
                <label for="message">Message:</label>
                <textarea class="form-control" type="text" id="message" name="message" required/>
            </div>
            <button type="submit">Submit</button>
        </ContactForm>
    )
}

export default ContactForm;